import { Dropdown, Icon } from 'semantic-ui-react';
import SignOut from '../auth/SignOut';

const tierNames = { 1: 'Bronze', 2: 'Silver', 3: 'Gold', 4: 'Diamond', 5: 'Platinum' };
const tierColors = { 1: '#CD7F32', 2: '#9E9E9E', 3: '#F5A623', 4: '#29B6F6', 5: '#B0BEC5' };

const Help = () => {
  const { firstName, companyID } = JSON.parse(window.localStorage.getItem('user'));
  const tierName = tierNames[companyID?.loyaltyTier];
  const tierColor = tierColors[companyID?.loyaltyTier];

  return (
    <Dropdown item trigger={
      <span>
        <Icon name='user outline' />
        {` Hello, ${firstName}`}
        {tierName && (
          <span style={{ fontSize: '0.65em', fontWeight: '700', letterSpacing: '0.05em', textTransform: 'uppercase', padding: '2px 7px', borderRadius: '10px', marginLeft: '6px', verticalAlign: 'middle', border: `1.5px solid ${tierColor}`, color: tierColor, background: 'transparent' }}>
            {tierName}
          </span>
        )}
      </span>
    }>
      <Dropdown.Menu>
        <SignOut />
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default Help;
